import reward from "./reward";
import agent from "./agent";
import member from "./member";
import announcement from "./announcement";
import myTeam from "./myTeam";
import level_distributed from "./level_distributed";
import accounting from '@/apis/tg_business/accounting';
import ranking from '@/apis/tg_business/ranking';

export default {
  agent,
  member,
  reward,
  announcement,
  myTeam,
  level_distributed,
  accounting,
  ranking
};
